<template>
    <div>
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <div v-else>
            <h3 class="mb-0">
                {{ data.type }}
                <span v-if="data.item_year != null"
                    >(Tahun {{ data.item_year }})</span
                >
                <b-badge class="ml-2" variant="warning">{{
                    status[data.status]
                }}</b-badge>
            </h3>
            {{ data.kind }} - {{ data.brand }}<br />
            {{ data.status == 55 ? "Request hilang" : "Approval" }} oleh

            <b-row class="mt-3">
                <b-col md="4">
                    <strong>No. Faktur PGI</strong><br />
                    {{ data.no_faktur_pgi }}
                </b-col>
                <b-col md="4">
                    <strong>IMEI/SN</strong><br />
                    {{ data.imei_sn }}
                </b-col>
                <b-col md="4">
                    <strong>Password</strong><br />
                    <div style="max-width: 250px; word-wrap: break-word;">
                        {{ data.password || "-- Tidak ada password --" }}
                    </div>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="4">
                    <strong>Grade</strong><br />
                    {{ data.grade_pgi }}
                </b-col>
                <b-col md="4">
                    <strong>Spek</strong><br />
                    {{ data.spec_pgi || "-" }}
                </b-col>
                <b-col md="4">
                    <strong>Kelengkapan</strong><br />
                    {{ data.is_batangan == true ? "Batangan" : "Lengkap" }}
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="4">
                    <strong>Gudang</strong><br />
                    {{ data.warehouse || "-" }}
                </b-col>
                <b-col md="4">
                    <strong>Deskripsi</strong><br />
                    {{ data.description || "-" }}
                </b-col>
            </b-row>
            <div class="mt-3">
                <strong>ADJUSTMENT HARGA</strong><br />
                Harga Dasar Sekarang:
                <strong
                    >Rp. {{ $helper.formatThousand(data.type_price) }}</strong
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isFetching: false,
            isSubmitting: false,

            data: {},

            status: {
                1: "PENDING"
            }
        };
    },
    props: {
        id: { type: Number, required: true }
    },
    methods: {
        init() {
            this.initStatus = 0;
            this.$axios
                .get(`inventory/pending/${this.id}`)
                .then(res => {
                    this.initStatus = 1;
                    this.data = res.data.data;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.initStatus = -1;
                });
        }
    },
    created() {
        this.init();
    }
};
</script>

<style></style>
